import type { ReactNode } from 'react'

import type {
  DataTableBulkAction,
  DataTableFilter,
  DataTableFilterValue,
} from './data-table.interface'

interface UseDataTableToolbarProps {
  searchValue?: string
  onSearchChange?: (value: string) => void
  searchPlaceholder?: string
  filterList?: DataTableFilter[]
  filterValueList?: DataTableFilterValue[]
  onFilterChange?: (filterValueList: DataTableFilterValue[]) => void
  selectedIdList: string[]
  bulkActionList?: DataTableBulkAction[]
  toolbarActions?: ReactNode
  isLoading: boolean
  onBulkAction: (actionId: string, selectedIdList: string[]) => void
}

interface UseDataTableToolbarReturn {
  hasToolbar: boolean
  toolbarProps: {
    searchValue?: string
    onSearchChange?: (value: string) => void
    searchPlaceholder?: string
    filterList?: DataTableFilter[]
    filterValueList?: DataTableFilterValue[]
    onFilterChange?: (filterValueList: DataTableFilterValue[]) => void
    selectedCount: number
    bulkActionList?: DataTableBulkAction[]
    onBulkAction: (actionId: string) => void
    toolbarActions?: ReactNode
  }
}

/**
 * Hook that prepares toolbar props from component props.
 */
export const useDataTableToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  filterList,
  filterValueList,
  onFilterChange,
  selectedIdList,
  bulkActionList,
  toolbarActions,
  isLoading,
  onBulkAction,
}: UseDataTableToolbarProps): UseDataTableToolbarReturn => {
  const hasToolbar =
    !!onSearchChange ||
    (filterList !== undefined && filterList.length > 0) ||
    toolbarActions !== undefined ||
    (bulkActionList !== undefined && bulkActionList.length > 0)

  return {
    hasToolbar,
    toolbarProps: {
      searchValue,
      onSearchChange,
      searchPlaceholder,
      filterList,
      filterValueList,
      onFilterChange,
      selectedCount: isLoading ? 0 : selectedIdList.length,
      bulkActionList: isLoading ? undefined : bulkActionList,
      onBulkAction: (actionId: string) => onBulkAction(actionId, selectedIdList),
      toolbarActions,
    },
  }
}
